/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createSymbolNode } from '../../factoriesNumber.js';
export var SymbolNodeDependencies = {
  NodeDependencies,
  createSymbolNode
};